import { post, get } from '@/utils/ajax';
import { slep } from '@/utils/slep';



export async function getTableList(data: object): Promise<any> {
    return get('/admin/basic/instance/list', data)

    // await slep(2000)
    // return {
    //     "list": [
    //         {
    //             "id": 72,
    //             "name": "组合购测试1",
    //             "merchant_num": 999999,
    //             "description": "",
    //             "icon": "",
    //             "activity_id": 2,
    //             "status": 5,
    //             "begin_at": "2020-01-02 12:12:12",
    //             "end_at": "2020-03-01 12:12:12",
    //             "options": {
    //                 "num": 2,
    //                 "test": "你好",
    //                 "template_id": 0,
    //             },
    //             "applet_url": "?merchantNum=999999&activity_instance_id=72",
    //             "created_at": "2020-02-25 14:58:06",
    //             "h5_url": "",
    //             "acitivity_type": "组合购",
    //             "support_type": 0
    //         }
    //     ],
    //     "total": 1,
    //     "page_size": 10,
    //     "page": 1,
    //     "last_page": 1
    // }
}
export async function getRecordTableList(data: object): Promise<any> {
    return get('/admin/activities/match-purchase/record/member-list', data)

    // await slep(2000)
    // return {
    //     "page": 1,
    //     "page_size": 10,
    //     "count": 1,
    //     "list": [
    //         {
    //             "nick": "pin",
    //             "date": "2019-02-02"
    //         }
    //     ]
    // }
}

export async function getLogTableList(data: object): Promise<any> {
    return get('/admin/basic/merchant/act-log', data)

    // await slep(2000)
    // return {
    //     "list": [
    //         {
    //             "id": 7,
    //             "merchant_num": 999999,  //商家编号
    //             "account": "lww",  //账号
    //             "source": 1,  //来源
    //             "activity_name": "test", //互动实例名称
    //             "action_desc": "创建互动", //操作动作
    //             "action_result": "",
    //             "is_display": 1,
    //             "created_at": "2020-02-29 15:58:58", //时间
    //             "updated_at": "2020-03-02 16:46:50",
    //             "deleted_at": null,
    //         }
    //     ],
    //     "total": 3,
    //     "page_size": 15,
    //     "page": 1,
    //     "last_page": 1
    // }
}



export async function onPublish(data: object): Promise<any> {
    return post('/admin/basic/instance/publish', data)
}

export async function onDelete(data: object): Promise<any> {
    return post('/admin/basic/instance/delete', data)
}

export async function onPaused(data: object): Promise<any> {
    return post('/admin/basic/instance/pause', data)
}

export async function onEnd(data: object): Promise<any> {
    return post('/admin/basic/instance/stop', data)
}

export async function createAct(data: object): Promise<any> {
    return post('/admin/activities/match-purchase/instance/create-or-update', data)
}

export async function actDetail(data: object): Promise<any> {
    return get('/admin/activities/match-purchase/instance/detail', data)
}

export async function copyUrl(data: object): Promise<any> {
    return get('/admin/basic/instance/get-applet-url', data)
}

export async function setMemberLink(data: object): Promise<any> {
    return post('/admin/basic/merchant/update-info', data)
}

export async function getSyncKey(data: object): Promise<any> {
    return post('/admin/basic/jd/goods/get-sync-key', data)
}

export async function getSyncResult(data: object): Promise<any> {
    return post('/admin/basic/jd/goods/query-sync-result', data)
}



